import { render } from "./ReceivingProductDetail.vue?vue&type=template&id=23b08678"
import script from "./ReceivingProductDetail.vue?vue&type=script&lang=js"
export * from "./ReceivingProductDetail.vue?vue&type=script&lang=js"

import "./ReceivingProductDetail.vue?vue&type=style&index=0&id=23b08678&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__